import { render, staticRenderFns } from "./WelcomeWidget.vue?vue&type=template&id=6065e4f6"
import script from "./WelcomeWidget.vue?vue&type=script&lang=js"
export * from "./WelcomeWidget.vue?vue&type=script&lang=js"
import style0 from "./WelcomeWidget.vue?vue&type=style&index=0&id=6065e4f6&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {WidgetScale: require('/home/runner/_work/plannr-nuxt/plannr-nuxt/components/WidgetScale.vue').default,WelcomeWidgetsWidgetItem: require('/home/runner/_work/plannr-nuxt/plannr-nuxt/components/welcomeWidgets/widgetItem.vue').default})
